import React from 'react';
import '../styles/SpeakerSpotlight.css';

const SpeakerSpotlight = ({ 
  name, 
  title, 
  badge, 
  description, 
  image, 
  stats 
}) => {
  return (
    <section className="speaker-spotlight">
      <div className="container">
        <div className="spotlight-content">
          {/* Left Side - Text Content */}
          <div className="spotlight-text">
            <h2 className="spotlight-name">{name}</h2>
            <h3 className="spotlight-title">{title}</h3>
            {badge && (
              <div className="spotlight-badge">{badge}</div>
            )}
            <p className="spotlight-description">{description}</p>
          </div>

          {/* Right Side - Image */}
          <div className="spotlight-image-wrapper">
            <div className="spotlight-image">
              <img src={image} alt={name} loading="lazy" />
            </div>
          </div>
        </div>

        {/* Stats Section */}
        {stats && stats.length > 0 && (
          <div className="spotlight-stats">
            {stats.map((stat, index) => (
              <div key={index} className="spotlight-stat-item">
                <div className="spotlight-stat-number">{stat.number}</div>
                <div className="spotlight-stat-label">{stat.label}</div>
                {stat.icon && (
                  <div className="spotlight-stat-icon">{stat.icon}</div>
                )}
                {stat.sublabel && (
                  <div className="spotlight-stat-sublabel">{stat.sublabel}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default SpeakerSpotlight;

















